import { render, staticRenderFns } from "./modalPriority.vue?vue&type=template&id=4fd398a2&scoped=true"
import script from "./modalPriority.vue?vue&type=script&lang=js"
export * from "./modalPriority.vue?vue&type=script&lang=js"
import style0 from "./modalPriority.vue?vue&type=style&index=0&id=4fd398a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd398a2",
  null
  
)

export default component.exports